import { render, staticRenderFns } from "./xeSelfRate.vue?vue&type=template&id=5a8113c9&scoped=true"
import script from "./xeSelfRate.vue?vue&type=script&lang=js"
export * from "./xeSelfRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8113c9",
  null
  
)

export default component.exports